export const services = [
  {
    id: 1,
    name: "Adaptive & Responsive Interfaces",
    description:
      "Designing experiences that adapt seamlessly across devices, screen sizes, and orientations, ensuring usability for both mobile-first and desktop-first audiences.",
  },
  {
    id: 2,
    name: "Scalable Architecture",
    description:
      "Building modular, component-driven UIs with reusable patterns to ensure long-term maintainability and easy feature expansion.",
  },
  {
    id: 3,
    name: "Performance Optimization",
    description:
      "Implementing strategies like lazy loading, image compression, and code splitting to reduce load times, improve SEO, and enhance Core Web Vitals.",
  },
  {
    id: 4,
    name: "Accessibility & Inclusivity",
    description:
      "Ensuring digital products are usable by everyone, including people with disabilities, by following WCAG standards and inclusive design practices.",
  },
  {
    id: 5,
    name: "Automated Testing & Debugging",
    description:
      "Leveraging unit tests, integration tests, and end-to-end tests with modern frameworks to deliver reliable, bug-free applications.",
  },
  {
    id: 6,
    name: "API Integration & State Management",
    description:
      "Seamlessly connecting front-end applications with APIs while managing global and local state efficiently using tools like Redux, Zustand, or React Query.",
  },
  {
    id: 7,
    name: "Security & Best Practices",
    description:
      "Implementing modern security measures such as input validation, HTTPS enforcement, and secure authentication flows.",
  },
  {
    id: 8,
    name: "Design Systems & Reusability",
    description:
      "Creating and maintaining design systems with consistent UI patterns for faster product development and scalable growth.",
  },
  {
    id: 9,
    name: "CI/CD & Deployment",
    description:
      "Integrating continuous delivery pipelines to streamline code deployment and ensure rapid, safe feature releases.",
  },
  {
    id: 10,
    name: "Cloud-Native Frontend",
    description:
      "Leveraging edge computing, CDNs, and serverless functions to deliver ultra-fast and resilient front-end experiences.",
  },
  {
    id: 11,
    name: "Progressive Web Apps (PWA)",
    description:
      "Building offline-capable, installable web apps that combine the reach of the web with the performance of native applications.",
  },
  {
    id: 12,
    name: "Micro-Frontends",
    description:
      "Architecting applications as independent, self-contained micro-frontends for scalability, modularity, and team autonomy.",
  },
  {
    id: 13,
    name: "Real-Time Applications",
    description:
      "Implementing WebSockets, GraphQL subscriptions, and server-sent events to enable real-time collaboration and live updates.",
  },
  {
    id: 14,
    name: "AI-Powered Interfaces",
    description:
      "Integrating machine learning models and AI APIs to create smarter, personalized, and predictive user experiences.",
  },
  {
    id: 15,
    name: "3D & Immersive Experiences",
    description:
      "Building interactive 3D visuals, AR/VR-ready experiences, and immersive UI components using WebGL, Three.js, and React Three Fiber.",
  },
  {
    id: 16,
    name: "Internationalization (i18n)",
    description:
      "Creating multilingual, culturally adaptive applications with robust internationalization and localization support.",
  },
  {
    id: 17,
    name: "DevOps for Frontend",
    description:
      "Automating builds, tests, and deployments with tools like Docker, GitHub Actions, and Vercel to improve delivery speed.",
  },
  {
    id: 18,
    name: "Data Visualization",
    description:
      "Designing advanced charts, dashboards, and visual analytics tools with libraries like Recharts, D3.js, and Chart.js.",
  },
  {
    id: 19,
    name: "Voice & Gesture Interfaces",
    description:
      "Implementing natural input systems such as voice commands, gesture control, and speech-to-text for next-gen interactions.",
  },
  {
    id: 20,
    name: "Ethical & Sustainable Design",
    description:
      "Focusing on privacy, low-energy consumption, and inclusive design practices to build digital products that respect users and the planet.",
  },
];
